import React from 'react';
import LoadingMask from '../../../CommonComponents/LoadingMask';
import {
  StyledUserActivityItem,
  UserActivityItemContent,
  UserActivityItemTitle,
  UserActivityItemTime,
} from './UserActivityItemStyles';

interface Props {}

export const UserActivityItemLoading: React.FC<Props> = () => {
  return (
    <StyledUserActivityItem>
      <LoadingMask width="50px" height="50px" isRound isDark />
      <UserActivityItemContent>
        <UserActivityItemTitle>
          <LoadingMask width="250px" height="20px" isDark />
        </UserActivityItemTitle>
      </UserActivityItemContent>
      <UserActivityItemTime>
        <LoadingMask width="50px" height="20px" isDark />
      </UserActivityItemTime>
    </StyledUserActivityItem>
  );
};
